import React, {useEffect, useState} from "react";
import {FaCaretLeft, FaCaretRight} from "react-icons/fa6";
import {Button, Divider, Layout, Menu, Row, Space, Typography} from "antd";
import style from "./Navbar.module.scss";
import styled from "styled-components";
import {connect, useDispatch, useSelector} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {RootState} from "store/store";
import {useTheme} from "shared/hooks/useThemeContent";
import {
    UserOutlined,
    InboxOutlined,
    PlusCircleFilled,
    AlignRightOutlined,
    HomeOutlined,
    BellOutlined
} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import Profile from "../../../../features/userProfile/pages/profile/Profile";
import {getUser} from "../../../../shared";
import {setValue} from "../../../../shared/slice/CurrentUser.slice";
import VerifyIdentityPopup from "../../../../shared/components/verifyIdentity/VerifyIdentityPopup";

const {Text} = Typography;

const {Sider} = Layout;
const DesktopSider = styled.div<{ show: boolean }>`
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
    background-color: #ffffff;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    z-index: 999;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 425px;
    transition: transform 0.3s ease, opacity 0.3s ease;
    transform: ${({ show }) => (show ? "translateY(0%) translateX(-50%)" : "translateY(100%) translateX(-50%)")};
    opacity: ${({ show }) => (show ? 1 : 0)};

    @media (max-width: 425px) {
        max-width: 100%;
        left: 0;
        transform: ${({ show }) => (show ? "translateY(0%)" : "translateY(100%)")};
        border-radius: 0;
    }
`;

const CustomText = styled(Text)`
    color: rgb(255 255 255 / 45%) !important;
`;

interface Props {
    menuItems: any;
    bottomMenuItems: any;
    getUser: any;
}

function Navbar({getUser}: Props) {
    const [activeIcon, setActiveIcon] = useState<string | null>(null);
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch<any>();
    const [showNavbar, setShowNavbar] = useState(true);
    const [isVerified, setIsVerified] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);
    const [openVerificationModal, setOpenVerificationModal] = useState<boolean>(false);
    const onCansel = () => {
        setOpenVerificationModal(false)
    }
    const onHandleOk = () => {
        setOpenVerificationModal(false)
        handleIconClick("plus")
        navigate('/ad-insert-step-one')
    }
    const getUserInfo = () => {
        getUser()
            .then((data: any) => {
                if (data.payload) {
                    setIsVerified(data.payload.data?.isAuthenticated)

                    dispatch(setValue(data.payload));
                }
            })
            .catch();
    };
    useEffect(() => {
        if (!!localStorage.getItem("jwt"))    getUserInfo()
    }, [localStorage]);
    // Define a function to set the active icon
    const handleIconClick = (icon: string) => {
        setActiveIcon(icon);
    };

    // Define styles for active and inactive icons
    const getIconStyle = (icon: string) => (
        {
            color: activeIcon === icon ? "rgba(215,20,151,0.8)" : "rgba(0, 0, 0, 0.45)", // use primary color for active
            fontSize: activeIcon === icon ? "22px" : "18px", // use primary color for active
        });
    const getPlusIconStyle = (icon: string) => (
        {
            color: activeIcon === icon ? "rgba(215,20,151,0.8)" : "#020D4D", // use primary color for active
            fontSize: activeIcon === icon ? "30px" : "30px", // use primary color for active
        });
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollTop = window.scrollY;

            if (currentScrollTop > lastScrollTop && currentScrollTop > 200) {
                // Scrolling down
                setShowNavbar(false);
            } else {
                // Scrolling up
                setShowNavbar(true);
            }

            setLastScrollTop(currentScrollTop);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollTop]);
    useEffect(() => {
        switch (location.pathname) {
            case '/':
                return handleIconClick("home")

            case '/category-list':
                return handleIconClick("menu")

            case '/ad-insert-step-one':
                return handleIconClick("plus")
            case '/user-profile':
                return handleIconClick("user")
            case '/BorrowRequests':
                return handleIconClick("BorrowRequests")


        }
    }, [location.pathname]);
    return (
        <DesktopSider show={showNavbar}>
            <Button
                type="text"
                icon={<HomeOutlined style={getIconStyle("home")}/>}
                onClick={() => {
                    handleIconClick("home")
                    navigate("/")
                }}
            />
            <Button
                type="text"
                icon={<AlignRightOutlined style={getIconStyle("menu")}/>}
                onClick={() => {
                    handleIconClick("menu")
                    navigate("/category-list")
                }}
            />
            <Button
                size="large"
                type="text"
                icon={<PlusCircleFilled style={getPlusIconStyle("plus")}/>}
                onClick={() => {
                    if (!!localStorage.getItem("jwt")){
                        if (isVerified){
                            handleIconClick("plus")
                            navigate('/ad-insert-step-one')
                        } else {
                            window.scrollTo({
                                top: 0,
                            });
                            setOpenVerificationModal(true)
                        }
                    }  else navigate("/login")

                }}
            />
            <Button
                type="text"
                icon={<InboxOutlined style={getIconStyle("BorrowRequests")}/>}
                onClick={() => {
                    if (!!localStorage.getItem("jwt")) {
                        handleIconClick("BorrowRequests")
                        navigate('/BorrowRequests')
                    } else navigate("/login")
                }}
            />
            <Button
                type="text"
                icon={<UserOutlined style={getIconStyle("user")}/>}
                onClick={() => {
                    if (!!localStorage.getItem("jwt")) {
                        handleIconClick("user")
                        navigate("/user-profile")
                    } else navigate("/login")

                }}
            />
            { openVerificationModal && <VerifyIdentityPopup open={openVerificationModal} onHandleCancel={onCansel} onHandleOk={onHandleOk}/>}

        </DesktopSider>
    );
}

export default connect(null, {getUser})(withRouter(Navbar));
